import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date, type, includeTime = false) => {
  if (type === "range" && Array.isArray(date)) {
    return JSON.stringify({
      startDate: date[0].format("YYYY-MM-DD"),
      endDate: date[1].format("YYYY-MM-DD"),
    });
  }
  
  // For hourly mode with time
  if (includeTime && date) {
    const formatted = JSON.stringify({
      startDate: date.format("YYYY-MM-DD"),
      startTime: date.format("HH:mm:ss"),
    });
    console.log("📅 formatDate with time:", formatted);
    return formatted;
  }
  
  return JSON.stringify(date.format("YYYY-MM-DD"));
};

// Dedicated function for formatting dates for Records table
export const formatDateForRecords = (date, timeRange) => {
  // If already an array (range), use standard formatDate
  if (Array.isArray(date)) {
    return JSON.stringify({
      startDate: date[0].format("YYYY-MM-DD"),
      endDate: date[1].format("YYYY-MM-DD"),
    });
  }
  
  // Clone the date to avoid mutation
  const clonedDate = dayjs(date);
  
  // Convert based on time range
  switch (timeRange) {
    case "month":
      // Convert single month date to full month range
      return JSON.stringify({
        startDate: clonedDate.startOf('month').format("YYYY-MM-DD"),
        endDate: clonedDate.endOf('month').format("YYYY-MM-DD"),
      });
      
    case "week":
      // Convert single week date to full week range
      return JSON.stringify({
        startDate: clonedDate.startOf('isoWeek').format("YYYY-MM-DD"),
        endDate: clonedDate.endOf('isoWeek').format("YYYY-MM-DD"),
      });
      
    case "day":
    case "hour":
    default:
      // For day and hour, use single date
      return JSON.stringify(clonedDate.format("YYYY-MM-DD"));
  }
};
